import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useRemoveDocumentQuery = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isSuccess } = useMutation(
    (id: string) => api.delete(API_URL.DOCUMENTS_BY_DOCUMENT_ID(id)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.DOCUMENTS_RECEIPTS],
        });
      },
    }
  );
  return {
    remove: mutateAsync,
    isLoading,
    isSuccess,
  };
};

export default useRemoveDocumentQuery;
